<template>
  <form @submit.prevent="submit" class="form" method="post">
    <div class="form-wrap">
      <label for="name">Name</label>
      <input v-model="sensor.name" class="form-input" type="text" name="name" id="name" />
    </div>
    <div class="form-wrap">
      <label for="hardware_id">Hardware ID</label>
      <input v-model="sensor.hardware_id" class="form-input" type="text" name="hardware_id" id="hardware_id" />
    </div>

    <div class="form-wrap select-wrap">
      <label for="sensor_type">{{ $t('sensors.sensorType') }}</label>
      <select v-model="sensor.sensor_type">
        <option value="" disabled>
          {{ $t('meta.pleaseSelect') }}
        </option>
        <option v-for="{ label, value } in sensorTypeOptions" :key="value" :value="value">
          {{ label }}
        </option>
      </select>
    </div>

    <div class="form-wrap">
      <label for="sensor_type">{{ $t('sensors.sensorPicture') }}</label>
      <input type="file" @change="setPicture" />
    </div>

    <input type="submit" :value="$t('meta.save')" class="button button-green button-100 button-round" />
  </form>
</template>

<script>
import sensorsApi from '@/api/sensors'

export default {
  props: {
    initialSensor: Object,
  },
  data() {
    return {
      sensor: this.initialSensor || {
        name: null,
        hardware_id: null,
        sensor_type: null,
      },
      sensorTypeOptions: [],
    }
  },
  methods: {
    submit() {
      this.$emit('submit', this.sensor)
    },
    setPicture() {},
  },
  async mounted() {
    this.sensorTypeOptions = await sensorsApi.selectableSensorTypes()
  },
}
</script>
